module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_005_small.015fa109.jpg";